<template>
    <div class="profile-tabs__wrapper">

        <div class="profile-tabs"  :class="tabOpen ? 'profile-tabs--open' : ''" v-if="transactions.array.length">

            <div class="profile-tabs__header-text"
                 @click.prevent="tabOpen = !tabOpen">
                {{ transactions.title }}
            </div>
            <transition name="slide" >

                <template  v-if="transactions.array.length">
                    <div class="profile-tabs__body" v-show="tabOpen">

                        <div class="profile-tabs__body-item d-flex" v-for="({pet = null, project = null,...item},index) in transactions.array" :key="index">

                            <template v-if="item && pet">
                                <div class="profile-tabs__body-header">
                                    <a :href="`/pets/${item.pet_id}`" class="profile-tabs__body-image">
                                        <img :src="`/storage/${pet.avatar.path.replace('original', 'avatar')}`" :alt="pet.name" v-if="pet.avatar">
                                        <span v-else v-text="getUserPM(pet.name || 'Anonymous')"></span>
                                    </a>
                                </div>

                                <div class="profile-tabs__body-content">
                                    <a :href="`/pets/${item.pet_id}`" class="profile-tabs__body-name">{{ pet.name }}</a>
                                    <div class="profile-tabs__body-info" v-text="">{{item.total_donated}} EUR {{$store.getters.t('user_profile_tabs_transferred')}}</div>

                                </div>
                            </template>

                            <template v-if="item && project">
                                <div class="profile-tabs__body-header">
                                    <a :href="`/projects/${item.project_id}`" class="profile-tabs__body-image">
                                        <img :src="`/storage/${project.avatar.path.replace('original', 'avatar')}`" :alt="project.name" v-if="project.avatar">
                                        <span v-else v-text="getUserPM(project.name || 'Anonymous')"></span>
                                    </a>
                                </div>

                                <div class="profile-tabs__body-content">
                                    <a :href="`/projects/${item.project_id}`" class="profile-tabs__body-name">{{ project.name }}</a>
                                    <div class="profile-tabs__body-info">{{item.total_donated}} EUR {{$store.getters.t('user_profile_tabs_transferred')}}</div>

                                </div>
                            </template>

                        </div>

                    </div>
                </template>
                <template v-else>
                    <div class="profile-tabs__body profile-tabs__body--empty d-flex" v-show="tabOpen">

                        {{$store.getters.t('facilities_list_empty')}}

                    </div>
                </template>

            </transition>

        </div>

    </div>
</template>

<script>

import Tabs from '../tabs/Tabs';
import Tab from '../tabs/Tab';

export default {
    name: "UserProfileTabs",
    props: ['user'],
    components: {Tabs, Tab},
    data() {
        return{

            transactionPage: 1,

            tabOpen: true,

            transactions:{
                title: this.$store.getters.t('organizations_profile_tabs_transactions'),
                selected: false,
                array: [],
                meta: null
            },
        }
    },


    mounted(){
        this.getDonationsByUser()
    },
    methods:{
        getDonationsByUser(){
            axios.get(`/user/${this.user.id}/donations/by-user`, {params: {per_page: 10, page: this.transactionPage}})
                .then(response => {
                    response = response.data;
                    if(response.success){

                        this.transactions.array = response.data
                    }

                })
                .catch(error => {

                    error = error.response.data

                    if(!error.success) console.log(error)


                })

        },


        getUserPM(name){
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },

    },

    watch:{
        transactionPage(){
            this.getDonationsByUser()
        },
    }
}
</script>

<style scoped>

</style>
